"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _dist = require("kubra-ux/dist");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faList = require("@fortawesome/free-solid-svg-icons/faList");

var _faCog = require("@fortawesome/free-solid-svg-icons/faCog");

var _DateFormatter = _interopRequireDefault(require("../../modules/DateFormatter"));

var _mapActions = require("../../actions/mapActions");

var _LegendItems = require("../../components/LegendItems");

var _NumberFormatter = _interopRequireDefault(require("../../modules/NumberFormatter"));

var _MenuTabGroup = _interopRequireDefault(require("../../components/MenuTabGroup"));

var _MenuTab = _interopRequireDefault(require("../../components/MenuTab"));

var _config = require("../../config");

var _reportActions = require("../../actions/reportActions");

var _RadioButtom = require("../../modules/RadioButtom");

var _permissions = _interopRequireDefault(require("../../config/permissions"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var SummaryField = function SummaryField(props) {
  var name = props.name,
      value = props.value,
      classNames = props.classNames,
      highlight = props.highlight,
      children = props.children;
  var combinedClassNames = "summary-field ".concat(highlight ? 'highlight' : '', " ").concat(classNames ? classNames.reduce(function (acc, curr) {
    return "".concat(acc, " ").concat(curr);
  }) : '');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: combinedClassNames
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'summary-field-group'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'summary-field-name'
  }, name), /*#__PURE__*/_react.default.createElement("span", {
    className: 'summary-field-value'
  }, children || value, "\xA0")));
};

SummaryField.propTypes = {
  name: _propTypes.default.string.isRequired,
  children: _propTypes.default.element,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  highlight: _propTypes.default.bool,
  classNames: _propTypes.default.arrayOf(_propTypes.default.string)
};

var ToolPanel = function ToolPanel() {
  var _layersConfig$find;

  var dispatch = (0, _reactRedux.useDispatch)();
  var activeLayer = (0, _reactRedux.useSelector)(function (state) {
    return state.layerVisibilityReducer.activeLayer || '';
  });
  var summary = (0, _reactRedux.useSelector)(function (state) {
    return state.summaryReducer.summary;
  });
  var visible = (0, _reactRedux.useSelector)(function (state) {
    return state.menuReducer.currentMenu === 'TOOLS';
  });

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state.layerPermissionReducer;
  }),
      visibilityConfig = _useSelector.visibilityConfig,
      userType = _useSelector.userType;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      selectedVisibility = _useState2[0],
      setSelectedVisibility = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedThematicVisibility = _useState4[0],
      setSelectedThematicVisibility = _useState4[1];

  var mapView = (0, _reactRedux.useSelector)(function (state) {
    return state.mapViewReducer.mapView;
  }, function () {
    return summary !== undefined;
  });

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      lastZoom = _useState6[0],
      setLastZoom = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = _slicedToArray(_useState7, 2),
      outagesSelected = _useState8[0],
      setOutagesSelected = _useState8[1];

  (0, _react.useEffect)(function () {
    setSelectedVisibility(_permissions.default[userType].defaultOutageLayer);
    setSelectedThematicVisibility(_permissions.default[userType].defaultThematicLayer);
  }, [userType]);
  (0, _react.useEffect)(function () {
    var wardOutageFlipPoint = 14;
    var countyWardFlipPoint = 12;
    var newZoom = mapView.zoom;

    if (!outagesSelected && newZoom !== lastZoom) {
      // county -> town ward
      if (lastZoom < countyWardFlipPoint && newZoom >= countyWardFlipPoint && !outagesSelected && selectedThematicVisibility === 'county') setSelectedThematicVisibility('townWard'); // town ward -> outages

      if (lastZoom < wardOutageFlipPoint && newZoom >= wardOutageFlipPoint && !outagesSelected && selectedThematicVisibility === 'townWard') setOutagesSelected(true);
    }

    if (newZoom !== lastZoom) {
      setLastZoom(newZoom);
    }
  }, [lastZoom, setLastZoom, mapView, outagesSelected, selectedThematicVisibility, setOutagesSelected]);
  (0, _react.useEffect)(function () {
    var requestedVisibility = outagesSelected ? selectedVisibility : selectedThematicVisibility;
    var visibilityOption = visibilityConfig.options.find(function (option) {
      return option.name === requestedVisibility;
    });

    if (visibilityOption) {
      var zoomLayer = visibilityOption.layers.find(function (layer) {
        if (layer.zoom === undefined) return true;

        if (layer.zoom.length === 1) {
          return layer.zoom[0] <= lastZoom;
        }

        if (layer.zoom.length === 2) {
          return layer.zoom[0] <= lastZoom && layer.zoom[1] >= lastZoom;
        }

        return false;
      });

      if (zoomLayer && zoomLayer.layerName !== activeLayer) {
        dispatch((0, _mapActions.setActiveLayer)(zoomLayer.layerName));
      }
    }
  }, [selectedVisibility, activeLayer, dispatch, lastZoom, selectedThematicVisibility, outagesSelected, visibilityConfig.options]);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: 'ToolPanel',
    style: {
      display: visible ? 'block' : 'none'
    }
  }, summary && /*#__PURE__*/_react.default.createElement("div", {
    id: 'map-summary'
  }, /*#__PURE__*/_react.default.createElement(SummaryField, {
    name: 'Active Outages'
  }, /*#__PURE__*/_react.default.createElement(_NumberFormatter.default, null, summary && typeof summary.total_outages === 'number' ? summary.total_outages : -1)), /*#__PURE__*/_react.default.createElement(SummaryField, {
    name: 'Affected Customers'
  }, /*#__PURE__*/_react.default.createElement(_NumberFormatter.default, null, (summary === null || summary === void 0 ? void 0 : summary.total_cust_a) || -1)), /*#__PURE__*/_react.default.createElement(SummaryField, {
    name: 'Total Customers Served'
  }, /*#__PURE__*/_react.default.createElement(_NumberFormatter.default, null, summary && typeof summary.total_cust_s === 'number' ? summary.total_cust_s : -1)), /*#__PURE__*/_react.default.createElement("div", {
    id: 'update-time'
  }, /*#__PURE__*/_react.default.createElement("span", null, "Last Updated: "), summary && /*#__PURE__*/_react.default.createElement(_DateFormatter.default, null, summary === null || summary === void 0 ? void 0 : summary.date_generated), /*#__PURE__*/_react.default.createElement("span", null, summary.update_wording['EN-US']))), /*#__PURE__*/_react.default.createElement(_MenuTabGroup.default, {
    defaultTab: 'MAP VIEWS'
  }, /*#__PURE__*/_react.default.createElement(_MenuTab.default, {
    icon: /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      color: 'white',
      icon: _faCog.faCog
    }),
    title: 'MAP VIEWS'
  }, /*#__PURE__*/_react.default.createElement(_RadioButtom.RadioButtonGroup, {
    disabled: false,
    classNames: [],
    size: 'large',
    selectedIndex: outagesSelected ? 0 : 1
  }, /*#__PURE__*/_react.default.createElement(_RadioButtom.RadioButton, {
    value: 'outages',
    classNames: ['category'],
    disabled: false,
    checked: outagesSelected,
    onClick: function onClick() {
      setOutagesSelected(true);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'layer-select-container'
  }, /*#__PURE__*/_react.default.createElement(_dist.DropdownField, {
    placeholder: 'Layer',
    classNames: 'form-dropdown',
    closeOnItemSelect: true,
    disabled: !outagesSelected,
    hideError: true,
    id: 'map-layer-select',
    labelPlacement: 'top',
    value: selectedVisibility,
    onChange: function onChange(selectedItem) {
      return setSelectedVisibility(selectedItem);
    }
  }, visibilityConfig.options.filter(function (option) {
    return option.name.includes('outage');
  }).map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_dist.MenuItem, {
      key: option.name,
      label: option.label,
      value: option.name
    });
  })))), /*#__PURE__*/_react.default.createElement(_RadioButtom.RadioButton, {
    value: 'thematics',
    classNames: ['category'],
    disabled: false,
    checked: !outagesSelected,
    onClick: function onClick() {
      setOutagesSelected(false);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'layer-select-container'
  }, /*#__PURE__*/_react.default.createElement(_dist.DropdownField, {
    placeholder: 'Layer',
    classNames: 'form-dropdown',
    closeOnItemSelect: true,
    disabled: outagesSelected,
    hideError: true,
    id: 'thematic-layer-select',
    labelPlacement: 'top',
    value: selectedThematicVisibility,
    onChange: function onChange(selectedItem) {
      return setSelectedThematicVisibility(selectedItem);
    }
  }, visibilityConfig.options.filter(function (option) {
    return !option.name.includes('outage');
  }).map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_dist.MenuItem, {
      key: option.name,
      label: option.label,
      value: option.name
    });
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    id: 'map-legend'
  }, /*#__PURE__*/_react.default.createElement("span", {
    id: 'layer-selection-label'
  }, "Customers Out:"), (_layersConfig$find = _config.layersConfig.find(function (layer) {
    return layer.layerName === activeLayer;
  })) === null || _layersConfig$find === void 0 ? void 0 : _layersConfig$find.layerRangeStyle.map(function (rangeStyle, index) {
    return /*#__PURE__*/_react.default.createElement(_LegendItems.LegendItem, {
      key: index,
      id: index.toString(),
      name: rangeStyle.label || '',
      icon: rangeStyle.icon ? /*#__PURE__*/_react.default.createElement("img", {
        src: rangeStyle.icon.url,
        alt: "".concat(rangeStyle.label, " icon")
      }) : undefined
    });
  }))), /*#__PURE__*/_react.default.createElement(_MenuTab.default, {
    icon: /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      color: 'white',
      icon: _faList.faList
    }),
    title: 'SUMMARY'
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: 'report-list'
  }, _config.reportsConfig.map(function (report) {
    return /*#__PURE__*/_react.default.createElement("button", {
      key: report.name,
      className: 'report-button',
      onClick: function onClick() {
        dispatch((0, _reportActions.setOpenReport)(report.name));
      }
    }, report.linkText);
  })))));
};

var _default = ToolPanel;
exports.default = _default;